/* eslint-disable class-methods-use-this */
import { currency, validateText, validateTextWithHypen, maskingPhoneNumber, formatMaskingPhoneNumber, getAddressData, remainingTimeSuffix, trimSpace, formatDate, } from '@/utils';
import { getRemainingTimeText, getRemainingTime, elapsedTimeFactor, getTimeText, } from '@/utils/time';
import { formatPhoneNumber, formatPhoneNumberReverse, } from '@/utils/regularExpression';
import { orderStatus as orderStatusConst, cancelType, payTypeCode, orderType, deliveryPayType, B2BDistributorIds, orderAgencyType, orderStatus, mapControl, } from '@/constants';
import { addressBaseOrder, orderTypeCode, shareDisplayType, } from '@/constants/global';
import { payMethodType, payMethodList, } from '@/constants/payMethod';
import { YOGI_DELIVERY, BAEMIN_ONE, O2PLUS_FOR_ADDRESS, SELF, } from '@/constants/orderAgencyType';
import { orderStatusGroup } from '@/constants/mapControl';
import { orderTypeForLocale } from '@/constants/orderType';
import dateFormatType from '@/constants/dateFormatType';
import { socketPayloadType } from '@/constants/socketPayloadType';
import OrderPolicy from '@/helpers/OrderPolicy';
import { i18n } from '@/locales';
import { getGlobalStore } from '@/lib/global-store';
import OrderAgencyOptions from '@/entity/OrderAgencyOptions';
export default class Order {
    mapControl = mapControl;
    /** 당일 번호 */
    todayNumber;
    /** 주문 아이디 */
    orderId;
    /** 상점 아이디 */
    storeId;
    /** 상점 이름 */
    storeName = '';
    /** 허브 아이디 */
    hubId = '';
    /** 허브 이름 */
    hubName;
    /** 총판 아이디 */
    distributorId;
    /** 상점 전화번호 */
    _storePhone;
    get storePhone() {
        return validateTextWithHypen(formatPhoneNumber(this._storePhone));
    }
    set storePhone(value) {
        this._storePhone = formatPhoneNumberReverse(value);
    }
    /** 배차 시간 */
    _allocatedAt;
    get allocatedAt() {
        return this._allocatedAt;
    }
    set allocatedAt(value) {
        this._allocatedAt = value;
    }
    /** 배차취소패널티 합산 금액 */
    _allocatedCancelPenaltyAmount = 0;
    get allocatedCancelPenaltyAmount() {
        return this._allocatedCancelPenaltyAmount;
    }
    set allocatedCancelPenaltyAmount(value) {
        this._allocatedCancelPenaltyAmount = value;
    }
    /** 배차취소패널티 횟수 */
    _allocatedCancelPenaltyCount = 0;
    get allocatedCancelPenaltyCount() {
        return this._allocatedCancelPenaltyCount;
    }
    /** 배차제한건수 */
    _allocateLimit;
    /** 취소시간 */
    _canceledAt;
    get canceledAt() {
        return this._canceledAt;
    }
    set canceledAt(value) {
        this._canceledAt = value;
    }
    _cancelFee;
    _customerSafePhone;
    /** 배달료 */
    _deliveryAmount;
    get deliveryAmount() {
        return this._deliveryAmount;
    }
    set deliveryAmount(value) {
        this._deliveryAmount = value;
    }
    /** 지불방식, 배달대행료지불방식 */
    _deliveryPayType;
    get deliveryPayType() {
        return this._deliveryPayType;
    }
    set deliveryPayType(value) {
        this._deliveryPayType = value;
    }
    get deliveryPayTypeForClient() {
        return Object.values(deliveryPayType).find((it) => this._deliveryPayType === it.value)?.text ?? '';
    }
    /** 거리 */
    _distanceKilometer;
    /** 거리 */
    get distanceKilometer() {
        return this._distanceKilometer;
    }
    /** 거리 */
    set distanceKilometer(value) {
        this._distanceKilometer = value;
    }
    /** 거리 + km  */
    get deliveryDistance() {
        return `${this._distanceKilometer}km`;
    }
    /** 완료 시간 */
    _finishedAt;
    get finishedAt() {
        return this._finishedAt;
    }
    set finishedAt(value) {
        this._finishedAt = value;
    }
    /** 허브 설정 DTO */
    _hubConfigurationDTO = undefined;
    get hubConfigurationDTO() {
        return this._hubConfigurationDTO;
    }
    set hubConfigurationDTO(value) {
        this._hubConfigurationDTO = value;
    }
    _includeAlcohol;
    /** 주문 유입 채널 */
    _orderAgencyId = null;
    /** 주문제휴사 아이디 */
    get orderAgencyId() {
        return this._orderAgencyId;
    }
    set orderAgencyId(value) {
        this._orderAgencyId = value;
    }
    _orderAgencyOptions = null;
    get orderAgencyOptions() {
        return this._orderAgencyOptions;
    }
    set orderAgencyOptions(value) {
        this._orderAgencyOptions = value;
    }
    /** 주문 금액 (요금, 상품 금액) */
    _orderAmount;
    get orderAmount() {
        return this._orderAmount;
    }
    set orderAmount(value) {
        this._orderAmount = value;
    }
    _pickedUpAt;
    get pickedUpAt() {
        return this._pickedUpAt;
    }
    set pickedUpAt(value) {
        this._pickedUpAt = value;
    }
    _pickupExpectedAt;
    get pickupExpectedAt() {
        return this._pickupExpectedAt;
    }
    set pickupExpectedAt(value) {
        this._pickupExpectedAt = value;
    }
    /** 프로모션 지원금 */
    _promotionSupportAmount;
    get promotionSupportAmount() {
        return this._promotionSupportAmount;
    }
    set promotionSupportAmount(value) {
        this._promotionSupportAmount = value;
    }
    /** 대행료합계 */
    _purchaseDeliveryCharge;
    get purchaseDeliveryCharge() {
        return this._purchaseDeliveryCharge;
    }
    set purchaseDeliveryCharge(value) {
        this._purchaseDeliveryCharge = value;
    }
    /** 배달대행료 계산 주체 */
    _purchaseType;
    /** 제휴사 서비스 수준 협약 배달 시간 */
    _serviceLevelAgreementDeliveryTime;
    _translatedStatus = '';
    _workerName;
    get workerName() {
        return validateTextWithHypen(this.allocatedWorkerName);
    }
    set workerName(value) {
        this._workerName = value;
    }
    /** 상점 메모 (출발지 메모) */
    _storeMemo;
    get storeMemo() {
        return validateTextWithHypen(this.pickupAddressMemo);
    }
    set storeMemo(value) {
        this._storeMemo = value;
    }
    /** 고객번호1 */
    _receiverPhone;
    get receiverPhone() {
        return formatPhoneNumber(validateText(this._receiverPhone));
    }
    set receiverPhone(value) {
        this._receiverPhone = formatPhoneNumberReverse(value);
    }
    /** 라이더 연락처 */
    _allocatedWorkerPhone;
    get allocatedWorkerPhone() {
        return validateTextWithHypen(formatPhoneNumber(this._allocatedWorkerPhone));
    }
    set allocatedWorkerPhone(value) {
        this._allocatedWorkerPhone = formatPhoneNumberReverse(value);
    }
    _deliveryId = '';
    get deliveryId() {
        const { orderId, todayNumber } = this;
        const todayNumberText = i18n.t('views.order_detail.order_detail_delivery_info.today_number_text', {
            todayNumber,
        });
        return `${orderId} ${todayNumberText}`;
    }
    set deliveryId(value) {
        this._deliveryId = value;
    }
    agencyShareInfo = {};
    allocatedDistributorId;
    allocatedHubId;
    allocatedHubName;
    allocatedWorkerCode;
    allocateLimit;
    cancelFee;
    cardApproveNumber;
    cardName = null;
    includeAlcohol;
    /** 배차 및 픽업 지연 상황 유무 */
    isDelayedState = false;
    isOpenedShareOrder = null;
    /** 공유건 여부 */
    isShareOrder = false;
    /** 특이사항 */
    memo;
    /** 주문 시간 */
    orderedAt;
    /** 배차취소시 임시적으로 이전 상태를 들고 있을 때 사용함 */
    originStatusCode = null;
    /** 이전 상태값 */
    preStatusCode;
    /** 상태 */
    statusCode = null;
    payCardAmount;
    payCashAmount;
    /** 결제방법 (만나서 결제할지 등등) */
    payTypeCode;
    /** 신규패턴 출발지 객체 */
    pickupAddress = null;
    pickupAddressBuildingName;
    pickupAddressBuildingNumber;
    pickupAddressDetail;
    pickupAddressDong;
    pickupAddressJibun;
    pickupAddressLi;
    pickupAddressMemo;
    pickupAddressRoad;
    pickupAddressSiDo;
    pickupAddressSiGunGu;
    pickupLatitude = null;
    pickupLongitude = null;
    /** 신규패턴 도착지 객체 */
    dropAddress = null;
    dropAddressBuildingName;
    dropAddressBuildingNumber;
    dropAddressDetail;
    dropAddressDong;
    dropAddressLi;
    dropAddressRoad;
    dropAddressSiDo;
    dropAddressSiGunGu;
    dropAddressJibun;
    dropLatitude = null;
    dropLongitude = null;
    /** 준비완료 시간 */
    preparedAt;
    prePayAmount;
    purchaseType;
    serviceLevelAgreementDeliveryTime;
    typeCode;
    vuexStore = null;
    workerCode;
    allocatedWorkerName;
    areaSurcharge;
    cancelTypeCode = null;
    configSurcharge;
    /** 상품할증료 */
    goodsPriceSurcharge;
    irregularSurcharge;
    policy;
    /** 라이더지원금 */
    workerSupportAmount;
    /** 페이로드 타입 */
    payloadType = '';
    /**
     * 배차요청 주문건 판단
     */
    get isWorkerRequested() {
        return this.statusCode === orderStatus.WORKER_REQUESTED.code;
    }
    get payTypes() {
        const { payCashAmount, payCardAmount, prePayAmount, _orderAmount, } = this;
        const mappedPayMethodList = payMethodList.map((it) => ({
            ...it,
            payCashAmount,
            payCardAmount,
            prePayAmount,
            orderAmount: _orderAmount,
        }));
        return mappedPayMethodList.filter((it) => it.predicate(this));
    }
    get orderType() {
        return OrderPolicy.getOrderType(this);
    }
    get orderTypeForClient() {
        return orderTypeForLocale[this.orderType];
    }
    get translatedStatus() {
        return i18n.t(orderStatusConst[this.statusCode]?.value
            ?? orderStatusConst.ACCEPTED.value);
    }
    set translatedStatus(value) {
        this._translatedStatus = value;
    }
    /** 경과시간 */
    get orderedAtElapsedTime() {
        return this.elapsedTimeSuffix(this.getElapsedTimeText(this.orderedAt));
    }
    get allocatedAtElapsedTimeSuffix() {
        return this.elapsedTimeSuffix(this.getElapsedTimeText(this._allocatedAt));
    }
    get pickedUpAtElapsedTimeSuffix() {
        return this.elapsedTimeSuffix(this.getElapsedTimeText(this._pickedUpAt));
    }
    get canceledReason() {
        return validateTextWithHypen(cancelType[this.cancelTypeCode]);
    }
    get pickupExpectedAtRemainingTimeSuffix() {
        // 서버에서 준 pickupExpectedAt은 초, 밀리초를 0으로 초기화해 주어 현재시간과 1분정도의 차이가 발생하는 문제가 있어
        // 현재시간의 초, 밀리초를 임의로 넣어 남은 시간 계산함
        const pickupExpectedAt = new Date(this.pickupExpectedAt);
        const now = new Date();
        pickupExpectedAt.setSeconds(now.getSeconds());
        pickupExpectedAt.setMilliseconds(now.getMilliseconds());
        return remainingTimeSuffix(getRemainingTimeText(pickupExpectedAt.getTime()));
    }
    get customerSafePhone() {
        const phoneNumber = validateText(this._customerSafePhone)
            || validateText(this._receiverPhone);
        if (OrderPolicy.doMaskCustomerSafePhone(this)) {
            const phoneNm = formatMaskingPhoneNumber(maskingPhoneNumber(phoneNumber));
            return validateTextWithHypen(phoneNm);
        }
        const phoneNm = formatPhoneNumber(phoneNumber);
        return validateTextWithHypen(phoneNm);
    }
    /** 대행료, 배달대행료 합계 */
    get totalDeliveryFee() {
        return currency(this._purchaseDeliveryCharge
            + this._promotionSupportAmount
            + this._allocatedCancelPenaltyAmount);
    }
    get orderAmountForClient() {
        if (this._orderAmount && this._orderAmount > 0) {
            return currency(this._orderAmount);
        }
        return currency(0);
    }
    get timelines() {
        const accepted = {
            color: 'green lighten-1',
            status: orderStatusConst.ACCEPTED.value,
            time: validateTextWithHypen(formatDate(this.orderedAt, dateFormatType.FULL_DATE)),
            isComplete: !OrderPolicy.isAcceptedStatus(this),
            isActive: true,
        };
        const isCompletePickup = OrderPolicy.isPickedUpStatus(this) || OrderPolicy.isFinishedStatus(this);
        const allocated = {
            color: 'green lighten-1',
            status: orderStatusConst.ALLOCATED.value,
            time: !OrderPolicy.isAcceptedStatus(this) ? validateTextWithHypen(formatDate(this._allocatedAt, dateFormatType.FULL_DATE)) : '-',
            isComplete: isCompletePickup,
            isActive: !OrderPolicy.isAcceptedStatus(this),
        };
        const pickedUp = {
            color: 'green lighten-1',
            status: orderStatusConst.PICKUP_FINISHED.value,
            time: validateTextWithHypen(formatDate(this._pickedUpAt, dateFormatType.FULL_DATE)),
            isComplete: OrderPolicy.isFinishedStatus(this),
            isActive: isCompletePickup,
        };
        const finished = {
            color: 'green lighten-1',
            status: orderStatusConst.DROP_FINISHED.value,
            time: validateTextWithHypen(formatDate(this._finishedAt, dateFormatType.FULL_DATE)),
            isComplete: OrderPolicy.isFinishedStatus(this),
            isActive: OrderPolicy.isFinishedStatus(this),
        };
        const canceled = {
            color: 'red darken-1',
            status: orderStatusConst.CANCELED.value,
            time: validateTextWithHypen(formatDate(this._canceledAt, dateFormatType.FULL_DATE)),
            isComplete: OrderPolicy.isCanceledStatus(this),
            isActive: OrderPolicy.isCanceledStatus(this),
        };
        if (OrderPolicy.isCanceledStatus(this)) {
            return [
                accepted,
                canceled,
            ];
        }
        return [
            accepted,
            allocated,
            pickedUp,
            finished,
        ];
    }
    /** 배달타입 => 배달 */
    get isDelivery() {
        return orderTypeCode.DELIVERY === this.typeCode;
    }
    /** 배달타입 => 퀵 */
    get isQuick() {
        return orderTypeCode.QUICK === this.typeCode;
    }
    get isDrinks() {
        // TODO: 추가 예정
        return false;
    }
    /** 비대면 여부 */
    get isUntact() {
        return this.payTypeCode === payTypeCode.UNTACT.code;
    }
    get orderCaution() {
        const lc = 'views.order_detail.order_detail_fulfillment_info.';
        const caution = {
            text: '-',
            textColor: 'text-black',
        };
        const quick = {
            text: `${lc}quick_service`,
            textColor: 'text-purple text-subtitle-2',
        };
        const untact = {
            text: `${lc}untact`,
            textColor: 'text-primary text-subtitle-2',
        };
        const { isQuick, isUntact, isDelivery } = this;
        if (isQuick) {
            return quick;
        }
        if (isDelivery && isUntact) {
            return untact;
        }
        return caution;
    }
    /** 결제수단 (카드, 현금, 등등) */
    get payMethod() {
        const { payCashAmount, payCardAmount, prePayAmount, _orderAmount, } = this;
        const mappedPayMethodList = payMethodList.map((it) => ({
            ...it,
            payCashAmount,
            payCardAmount,
            prePayAmount,
            orderAmount: _orderAmount,
        }));
        return mappedPayMethodList.filter((it) => it.predicate(this));
    }
    get goodsNamesText() {
        return validateText(this.goodsNames);
    }
    get goodsNamesHypenInsteadOfEmpty() {
        return validateTextWithHypen(this.goodsNames);
    }
    /** 카드결제 승인 여부 */
    get isCardApproved() {
        // TODO: 기획과 디자인 작업 때까지 숨김 처리
        return false;
        // return !!this.cardApproveNumber;
    }
    /** 카드결제 주문건 여부 */
    get isCardOrder() {
        return this.payMethod.some(({ code }) => code === payMethodType.PAY_CARD_AMOUNT);
    }
    /** 주문 취소 가능 여부 */
    get isPossibleOrderCancel() {
        // 자사콜이면 무조건 취소 가능
        if (OrderPolicy.getOrderType(this) === orderType.OWN) {
            return true;
        }
        // 자사콜이 아닌 b2b거나 공유콜은 취소 불가
        if (OrderPolicy.isB2B(this)
            || OrderPolicy.getOrderType(this) === orderType.SHARED) {
            return false;
        }
        return true;
    }
    get statusAlias() {
        if (OrderPolicy.isAllocatedStatus(this)) {
            return orderStatusConst.ALLOCATED.value;
        }
        if (OrderPolicy.isPickedUpStatus(this)) {
            return orderStatusConst.PICKUP_FINISHED.value;
        }
        if (OrderPolicy.isFinishedStatus(this)) {
            return orderStatusConst.DROP_FINISHED.value;
        }
        return '';
    }
    /**
     * 공유 허브 노출 제외건 여부
     */
    get isShareDisplayN() {
        return this.agencyShareInfo.shareDisplayYn === shareDisplayType.N;
    }
    get isAccepted() {
        return this.statusCode === orderStatus.ACCEPTED.code;
    }
    /** 할부 개월 */
    month;
    /** 비과세(보증금) */
    taxFreePayAmount;
    /** 준비상태 출력용 */
    get preparedState() {
        return this.preparedAt ? '준비완료' : '준비중';
    }
    /** 취소 메모 */
    cancelMemo;
    /**
     * 푸시 데이터 컨버팅
     * @param pushData
     * @returns pushData
     */
    static convertPushData(pushData) {
        const { payloadType, changedAt, pickupLocation, dropAddressJibun, } = pushData;
        if (payloadType === socketPayloadType.PICKUP_FINISH) {
            return {
                ...pushData,
                updatedAt: changedAt,
                pickedUpAt: changedAt,
            };
        }
        if (payloadType === socketPayloadType.PAYMENT) {
            return {
                ...pushData,
                cardName: pushData?.cardCompany,
                cardApproveNumber: pushData.approveNumber,
            };
        }
        if (payloadType === socketPayloadType.PAY_AMOUNT) {
            return {
                ...pushData,
                orderAmount: pushData.orderAmount,
            };
        }
        if (payloadType === socketPayloadType.DELIVERY_CHARGE) {
            return {
                ...pushData,
                distanceKilometer: pushData.distanceKilometer,
                deliveryAmount: pushData.deliveryCharge,
                purchaseDeliveryCharge: pushData.totalDeliveryCharge,
            };
        }
        if (payloadType === socketPayloadType.DROP_INFO) {
            // TODO: 임시 작업 특정키 없을 경우 임시 추가
            // https://barogo.slack.com/archives/C01A1R67RFA/p1646904211152869
            return {
                dropAddressJibun: dropAddressJibun || '',
                pickupLatitude: pickupLocation.latitude,
                pickupLongitude: pickupLocation.longitude,
                ...pushData,
            };
        }
        return pushData;
    }
    constructor({ finishedAt: _finishedAt, receiverPhone: _receiverPhone, customerSafePhone: _customerSafePhone, orderAmount: _orderAmount, allocatedAt: _allocatedAt, canceledAt: _canceledAt, pickedUpAt: _pickedUpAt, purchaseDeliveryCharge: _purchaseDeliveryCharge, deliveryPayType: _deliveryPayType, pickupExpectedAt: _pickupExpectedAt, allocatedWorkerPhone: _allocatedWorkerPhone, storePhone: _storePhone, promotionSupportAmount: _promotionSupportAmount, deliveryAmount: _deliveryAmount, distanceKilometer: _distanceKilometer, allocatedCancelPenaltyAmount: _allocatedCancelPenaltyAmount, allocatedCancelPenaltyCount: _allocatedCancelPenaltyCount, orderAgencyId: _orderAgencyId, orderAgencyOptions: _orderAgencyOptions, hubConfigurationDTO: _hubConfigurationDTO, includeAlcohol: _includeAlcohol, allocateLimit: _allocateLimit, purchaseType: _purchaseType, cancelFee: _cancelFee, serviceLevelAgreementDeliveryTime: _serviceLevelAgreementDeliveryTime, ..._order } = {}) {
        // TODO: Order는 속성이 많아서 한번에 다 옮기기 많아서 필요한 경우에 추가
        Object.assign(this, {
            ..._order,
            _finishedAt,
            _receiverPhone,
            _customerSafePhone,
            _orderAmount,
            _allocatedAt,
            _canceledAt,
            _pickedUpAt,
            _purchaseDeliveryCharge,
            _deliveryPayType,
            _pickupExpectedAt,
            _allocatedWorkerPhone,
            _storePhone,
            _promotionSupportAmount,
            _deliveryAmount,
            _distanceKilometer,
            _allocatedCancelPenaltyAmount,
            _allocatedCancelPenaltyCount,
            _orderAgencyId,
            _orderAgencyOptions,
            _hubConfigurationDTO,
            _includeAlcohol,
            _allocateLimit,
            _purchaseType,
            _cancelFee,
            _serviceLevelAgreementDeliveryTime,
        });
        this.orderId = validateText(this.orderId);
        this.policy = {
            isCancelAcceptedAvailable: OrderPolicy.isCancelAcceptedAvailable(this),
            isCancelAllocatedAvailable: OrderPolicy.isCancelAllocatedAvailable(this),
            isReallocateAvailable: OrderPolicy.isReallocateAvailable(this),
            isCustomerSupportAvailable: OrderPolicy.isCustomerSupportAvailable(this),
            isAllocateAvailable: OrderPolicy.isAllocateAvailable(this),
            isChangeDropAddressAvailable: OrderPolicy.isChangeDropAddressAvailable(this),
            isDeliveryIdShow: OrderPolicy.isAcceptedStatus(this)
                || OrderPolicy.isAllocatedStatus(this)
                || OrderPolicy.isPickedUpStatus(this)
                || OrderPolicy.isFinishedStatus(this)
                || OrderPolicy.isCanceledStatus(this),
            isElapsedTimeShow: OrderPolicy.isAcceptedStatus(this)
                || OrderPolicy.isAllocatedStatus(this)
                || OrderPolicy.isPickedUpStatus(this)
                || OrderPolicy.isFinishedStatus(this),
            isAllocatedAtShow: OrderPolicy.isAllocatedStatus(this)
                || OrderPolicy.isPickedUpStatus(this)
                || OrderPolicy.isFinishedStatus(this),
            isAllocatedAtElapsedTimeShow: OrderPolicy.isAllocatedStatus(this)
                || OrderPolicy.isPickedUpStatus(this),
            isPickedUpAtShow: OrderPolicy.isPickedUpStatus(this)
                || OrderPolicy.isFinishedStatus(this),
            isPickedUpAtElapsedTimeShow: OrderPolicy.isPickedUpStatus(this),
            isFinishedAtShow: OrderPolicy.isFinishedStatus(this),
            isCanceledAtShow: OrderPolicy.isCanceledStatus(this),
            isCanceledReasonShow: OrderPolicy.isCanceledStatus(this),
            isPickupExpectedAtShow: OrderPolicy.isAcceptedStatus(this)
                || OrderPolicy.isAllocatedStatus(this)
                || OrderPolicy.isPickedUpStatus(this)
                || OrderPolicy.isFinishedStatus(this)
                || OrderPolicy.isCanceledStatus(this),
            isPickupExpectedAtRemainingTimeShow: OrderPolicy.isAcceptedStatus(this)
                || OrderPolicy.isAllocatedStatus(this),
            isPickupWishAtAvailable: OrderPolicy.isPickupWishAtAvailable(this),
            isPickupDelayWishAtAvailable: OrderPolicy.isPickupDelayWishAtAvailable(this),
            isDeliveryDistanceShow: OrderPolicy.isAcceptedStatus(this)
                || OrderPolicy.isAllocatedStatus(this)
                || OrderPolicy.isPickedUpStatus(this)
                || OrderPolicy.isFinishedStatus(this)
                || OrderPolicy.isCanceledStatus(this),
            isDeliveryChargeShow: OrderPolicy.isAcceptedStatus(this)
                || OrderPolicy.isAllocatedStatus(this)
                || OrderPolicy.isPickedUpStatus(this)
                || OrderPolicy.isFinishedStatus(this)
                || OrderPolicy.isCanceledStatus(this),
            isAdjustDeliveryAmountAvailable: OrderPolicy.isAdjustDeliveryAmountAvailable(this),
            isWorkerSupportAmountAvailable: OrderPolicy.isWorkerSupportAmountAvailable(this),
            isMaskingCustomerSafePhoneShow: OrderPolicy.doMaskCustomerSafePhone(this),
            isAdjustPaymentShow: OrderPolicy.isAdjustPaymentAvailable(this),
        };
        this.initOrderAgencyOptions();
        // this.legacyMapOrderConstructor(this);
        this.vuexStore = getGlobalStore();
        // this._initData();
        this.storeId = this.isQuick ? orderTypeCode.QUICK : this.storeId;
        this._adjustOrderState();
        this._trimAddress();
    }
    /**
     * 주문 상태 보정
     */
    _adjustOrderState() {
        if (this.statusCode === orderStatus.PICKUP_ARRIVED.code) {
            this.statusCode = orderStatus.ALLOCATED.code;
        }
    }
    /**
     * 검색에 필요한 빈문자 제거된 주소
     */
    _trimAddress() {
        return {
            storeName: trimSpace(this.storeName),
            allocatedWorkerName: trimSpace(this.allocatedWorkerName),
            allocatedHubName: trimSpace(this.allocatedHubName),
            pickupAddressMemo: trimSpace(this.pickupAddressMemo),
            fullPickupAddress: trimSpace(this.getFullPickupAddress()),
            fullDropAddressShorten: trimSpace(this.getDropAddressShorten()),
        };
    }
    /** 주문제휴사 클라이언트용 */
    orderAgencyIdForClient() {
        if (!this._orderAgencyId) {
            return '';
        }
        return orderAgencyType[this._orderAgencyId];
    }
    /**
     * 발주허브명 조회
     */
    hubNameWithHypen() {
        let result = validateTextWithHypen(this.hubName);
        // 주소기반이면 허브 이름을 주문제휴사명으로 교체
        if (this.orderAgencyId !== SELF
            && this.orderAgencyId !== null) {
            result = orderAgencyType[this.orderAgencyId];
        }
        return validateTextWithHypen(result);
    }
    /**
     * 주문 바디에 있는 출발지 주소 영역
     */
    getOrderBodyText() {
        if (this.typeCode === orderTypeCode.DELIVERY) {
            if (!this.pickupAddressMemo) {
                return this.storeName;
            }
            return this.pickupAddressMemoWithOrderAgency();
        }
        return '';
    }
    /**
     * 지연상태에 따른 값
     * @returns
     */
    displayTime() {
        const isUnderMinutes = (minutes) => (factor) => {
            if (!factor.positive) {
                return true;
            }
            const factorMinutes = factor.hours * 60 + factor.minutes;
            if (factorMinutes <= minutes) {
                return true;
            }
            return false;
        };
        const isOverMinutes = (minutes) => (factor) => {
            const factorMinutes = factor.hours * 60 + factor.minutes;
            if (factorMinutes > minutes) {
                return true;
            }
            return false;
        };
        // 최초 남은시간이 5분 초과 접수,배차 배달
        const under5Minutes = isUnderMinutes(5);
        const under10Minutes = isUnderMinutes(10);
        // 최초 남은시간이 5분 이하 접수,배차 배달
        const under3Minutes = isUnderMinutes(3);
        const under4Minutes = isUnderMinutes(4);
        const under0Minutes = isUnderMinutes(0);
        // 픽업 경과 시간
        const over30Minutes = isOverMinutes(30);
        // Lv1. 정상
        const normalColor = 'brg-color-grey-600';
        // Lv2. 경고. 약한 경고
        const alertColor = 'text-red-lighten-1';
        // Lv3. 비상. 강한 경고
        const emergencyColor = 'text-red-darken-2';
        const result = {
            text: '',
            color: '',
            isDelayedOrder: false,
        };
        // 접수건일 경우
        if (OrderPolicy.isAcceptedStatus(this)) {
            const _5MinutesInMillis = 5 * 60 * 1_000;
            const isFirstRemainTimeOver5Minutes = this.pickupExpectedAt - this.orderedAt > _5MinutesInMillis;
            const isAlert = isFirstRemainTimeOver5Minutes ? under10Minutes : under4Minutes;
            const isEmergency = isFirstRemainTimeOver5Minutes ? under5Minutes : under3Minutes;
            const { text, factor } = getRemainingTime(this.pickupExpectedAt);
            if (isEmergency(factor)) {
                result.color = emergencyColor;
            }
            else if (isAlert(factor)) {
                result.color = alertColor;
            }
            else {
                result.color = normalColor;
            }
            result.isDelayedOrder = this.checkDelayedOrder(text);
            result.text = remainingTimeSuffix(text);
            return result;
        }
        // 배차건일 경우
        if (OrderPolicy.isAllocatedStatus(this)) {
            const isEmergency = under0Minutes;
            const isAlert = under5Minutes;
            const { text, factor } = getRemainingTime(this.pickupExpectedAt);
            if (isEmergency(factor)) {
                result.color = emergencyColor;
            }
            else if (isAlert(factor)) {
                result.color = alertColor;
            }
            else {
                result.color = normalColor;
            }
            result.isDelayedOrder = this.checkDelayedOrder(text);
            result.text = remainingTimeSuffix(text);
            return result;
        }
        // 픽업건일 경우
        if (OrderPolicy.isPickedUpStatus(this)) {
            const isEmergency = over30Minutes;
            const { text, factor } = this.getElapsedTime(this.pickedUpAt);
            if (isEmergency(factor)) {
                result.color = emergencyColor;
                result.isDelayedOrder = true;
            }
            else {
                result.color = normalColor;
            }
            result.text = this.elapsedTimeSuffix(text);
            return result;
        }
        if (OrderPolicy.isFinishedStatus(this)) {
            result.text = formatDate(this.finishedAt, dateFormatType.FULL_DATE);
            return result;
        }
        if (OrderPolicy.isCanceledStatus(this)) {
            result.text = formatDate(this._canceledAt, dateFormatType.FULL_DATE);
            return result;
        }
        return result;
    }
    /** 배달대행료 */
    deliveryAgencyFee() {
        const amount = (this._purchaseDeliveryCharge
            + this._promotionSupportAmount) - (this.workerSupportAmount
            + this.configSurcharge
            + this.irregularSurcharge
            + this.areaSurcharge
            + this.goodsPriceSurcharge
            + this._promotionSupportAmount);
        return currency(amount);
    }
    goodsNames() {
        return validateText(this.goodsNames);
    }
    getElapsedTime(time) {
        const factor = elapsedTimeFactor(time);
        const text = getTimeText(factor);
        return {
            text,
            factor,
        };
    }
    getElapsedTimeText(time) {
        const { text } = this.getElapsedTime(time);
        return text;
    }
    elapsedTimePrefix(text) {
        return i18n.t('common.prefix_elapsed_time', {
            elapsedTime: text,
        });
    }
    elapsedTimeSuffix(text) {
        return i18n.t('common.suffix_elapsed_time', {
            elapsedTime: text,
        });
    }
    remainingTimePrefix(text) {
        return i18n.t('common.prefix_remaining_time', {
            remainingTime: text,
        });
    }
    attentions() {
        const lc = 'views.order_list.order_list_item.';
        const quick = {
            text: `${lc}quick`,
            textColor: 'text-purple-lighten-1',
        };
        const untact = {
            text: `${lc}untact`,
            textColor: 'text-primary-lighten-1',
        };
        const drinks = {
            text: `${lc}drinks`,
            textColor: 'text-red-lighten-1',
        };
        // 퀵은 혼자만 존재
        if (this.isQuick) {
            return [
                quick,
            ];
        }
        const list = [];
        if (this.isUntact) {
            list.push(untact);
        }
        if (this.isDrinks) {
            list.push(drinks);
        }
        return list;
    }
    pickupAddressOnListItem() {
        if (this.isDelivery) {
            return this.storeMemo || this.storeName;
        }
        return this.pickupAddressShorten();
    }
    dropAddressOnListItem() {
        return this.dropAddressShorten();
    }
    /** 쓰는 곳 없음 */
    // pdaMemo = () => this.pdaMemo
    // TODO: 바로 치환해서 리턴하는건 어떨지 확인 필요. 호출하는 쪽에서 치환하는 것이 번거로움
    status() {
        return orderStatusConst[this.statusCode]?.value
            ?? orderStatusConst.ACCEPTED.value;
    }
    statusChipType() {
        const value = orderStatusConst[this.statusCode].statusChipType;
        if (value) {
            return value;
        }
        return orderStatusConst.ACCEPTED.statusChipType;
    }
    /**
     * 공유 주문 여부
     * @param subscribeHubId 구독중인 허브 아이디
     */
    setShareOrder(subscribeHubId) {
        if (!subscribeHubId) {
            console.log('[setShareOrder] invalid parameter');
            return;
        }
        if (this.isAddressBaseOrder()) {
            this.isShareOrder = false;
            return;
        }
        if (this.isB2B()) {
            this.isShareOrder = false;
            return;
        }
        const keyName = subscribeHubId.indexOf('H') === 0
            ? 'distributorId'
            : 'hubId';
        if (subscribeHubId !== this[keyName]) {
            this.isShareOrder = true;
            return;
        }
        this.isShareOrder = false;
    }
    setIsDelayedState(value) {
        this.isDelayedState = value;
    }
    /**
     * 공유주문 + 배차건 + 내 라이더가 배차한 건이 아님
     * 이 경우 비노출 되어야 함
     * @returns {boolean}
     */
    isShareOrderAndNotMyWorker() {
        return this.isShareOrder && this.isAllocatedOrder() && !this.isAllocatedMyWorker();
    }
    /**
     * 배차건인지 채크
     * @returns {boolean}
     */
    isAllocatedOrder() {
        const orderStatusCode = orderStatusGroup[this.statusCode];
        const validStatusCode = [
            orderStatus.ALLOCATED.code,
            orderStatus.PICKUP.code,
        ];
        return validStatusCode.some((code) => code === orderStatusCode);
    }
    /**
     * 내 라이더가 배차한 건인지 판단
     * @returns {boolean}
     */
    isAllocatedMyWorker() {
        const isHubType = this.vuexStore.getters['hubSelector/getterIsSubscribeHub'];
        const subscribeHubId = this.vuexStore.getters['hubSelector/getterSubscribeHubId'];
        const compareKey = isHubType
            ? 'allocatedHubId'
            : 'allocatedDistributorId';
        const workerTargetId = this[compareKey];
        // 구독중인 허브의 워커인지 판단
        return subscribeHubId === workerTargetId;
    }
    /**
     * 주소기반 주문인지 판단
     */
    isAddressBaseOrder() {
        if (addressBaseOrder.includes(this.hubId)) {
            return true;
        }
        return false;
    }
    /**
     * B2B 건 유무 확인
     * 주소기반은 총판이 b2b총판과 같기 때문에 b2b 판단 전에 주소기반인지를 판단해야 함
     * TODO : OrderPolicy 파일 호출시 순환 참조 발생. 구조 개선 필요..
     */
    isB2B() {
        // 주소 기반은 모두 b2b 총판에 속하기 때문에 b2b 판단 전에 주소기반을 판단해야 한다.
        if (this.isAddressBaseOrder()) {
            return false;
        }
        if (B2BDistributorIds.O_B2B.includes(this.distributorId)) {
            return true;
        }
        return false;
    }
    setOpenedShareOrder(flag) {
        this.isOpenedShareOrder = flag;
    }
    /**
     * 출발지 주소 짧은 주소
     */
    pickupAddressShorten() {
        const { eupMyeonDong, li, jibun, buildingName, detail, } = getAddressData({
            inEupMyeonDong: this.pickupAddressDong,
            inLi: this.pickupAddressLi,
            inJibun: this.pickupAddressJibun,
            inBuildingName: this.pickupAddressBuildingName,
            inDetail: this.pickupAddressDetail,
        });
        return [
            eupMyeonDong,
            li,
            jibun,
            buildingName,
            detail,
        ]
            .filter((it) => !!it)
            .join(' ');
    }
    /**
   * 출발지 주소: 주소기반 배달시 출발지 주소 앞에 표기 추가
   */
    pickupAddressMemoWithOrderAgency() {
        if (!this.isAddressBaseOrder()) {
            return this.pickupAddressMemo;
        }
        const orderAgencyText = [];
        let orderAgencyTextResult = '';
        // 요기
        if (this.orderAgencyId === YOGI_DELIVERY) {
            orderAgencyText.push(`${i18n.t('common.yogi_delivery_acronym')}`);
        }
        // 배민
        if (this.orderAgencyId === BAEMIN_ONE) {
            orderAgencyText.push(`${i18n.t('common.baemin_one_acronym')}`);
        }
        // 오투플러스
        if (this.orderAgencyId === O2PLUS_FOR_ADDRESS) {
            orderAgencyText.push(`${i18n.t('common.o2plus_for_address_acronym')}`);
        }
        if (this.orderAgencyOptions?.allocateLimit === 1) {
            orderAgencyText.push(`${i18n.t('common.unit')}`);
        }
        if (orderAgencyText.length > 0) {
            orderAgencyTextResult = `[${orderAgencyText.join('')}] `;
        }
        // this.pickupAddressMemo 가 null 인 경우 null이 아닌 - 로 출력 되도록 대응
        if (orderAgencyTextResult.length === 0 && this.pickupAddressMemo === null) {
            return '-';
        }
        return `${orderAgencyTextResult}${this.pickupAddressMemo}`;
    }
    getDropAddressShorten() {
        const { eupMyeonDong, li, jibun, buildingName, detail, } = getAddressData({
            inEupMyeonDong: this.dropAddressDong,
            inLi: this.dropAddressLi,
            inJibun: this.dropAddressJibun,
            inBuildingName: this.dropAddressBuildingName,
            inDetail: this.dropAddressDetail,
        });
        return [
            eupMyeonDong,
            li,
            jibun,
            buildingName,
            detail,
        ]
            .filter((it) => !!it)
            .join(' ');
    }
    /**
     * 출발지
     */
    getFullPickupAddress() {
        const { siDo, siGunGu, eupMyeonDong, li, jibun, buildingNumber, buildingName, enclosedRoad, detail, } = getAddressData({
            inSiDo: this.pickupAddressSiDo,
            inSiGungu: this.pickupAddressSiGunGu,
            inEupMyeonDong: this.pickupAddressDong,
            inLi: this.pickupAddressLi,
            inJibun: this.pickupAddressJibun,
            inRoad: this.pickupAddressRoad,
            inBuildingNumber: this.pickupAddressBuildingNumber,
            inBuildingName: this.pickupAddressBuildingName,
            inDetail: this.pickupAddressDetail,
        });
        return [
            siDo,
            siGunGu,
            eupMyeonDong,
            li,
            jibun,
            buildingNumber,
            buildingName,
            enclosedRoad,
            detail,
        ]
            .filter((it) => !!it)
            .join(' ');
    }
    /**
     * 도착지
     * 개인정보 적용
     */
    getFullDropAddress() {
        const { siDo, siGunGu, eupMyeonDong, li, jibun, buildingNumber, buildingName, enclosedRoad, detail, } = getAddressData({
            inSiDo: this.dropAddressSiDo,
            inSiGungu: this.dropAddressSiGunGu,
            inEupMyeonDong: this.dropAddressDong,
            inLi: this.dropAddressLi,
            inJibun: this.dropAddressJibun,
            inRoad: this.dropAddressRoad,
            inBuildingNumber: this.dropAddressBuildingNumber,
            inBuildingName: this.dropAddressBuildingName,
            inDetail: this.dropAddressDetail,
        });
        if (OrderPolicy.doMaskDropInfo(this)) {
            return [
                eupMyeonDong,
                li,
                jibun,
            ]
                .filter((it) => !!it)
                .join(' ').concat('*'.repeat(6));
        }
        return [
            siDo,
            siGunGu,
            eupMyeonDong,
            li,
            jibun,
            buildingNumber,
            buildingName,
            enclosedRoad,
            detail,
        ]
            .filter((it) => !!it)
            .join(' ');
    }
    /**
     * 출발지 주소 전체 주소
     * */
    getPickupFullAddress() {
        let address = {};
        if (this.pickupAddress?.siDo) {
            address = getAddressData({
                inSiDo: this.pickupAddress.siDo,
                inSiGungu: this.pickupAddress.siGunGu,
                inBuildingName: this.pickupAddress.buildingName,
                inDetail: this.pickupAddress.detail,
                // lotNumber / 지번 / 구주소
                inEupMyeonDong: this.pickupAddress.lotNumber.dong,
                inLi: this.pickupAddress.lotNumber.ri,
                inJibun: `${this.pickupAddress.lotNumber.subNumber
                    ? `${this.pickupAddress.lotNumber.mainNumber}-${this.pickupAddress.lotNumber.subNumber}`
                    : this.pickupAddress.lotNumber.mainNumber}`,
                // roadName / 도로명 / 신주소
                inRoad: this.pickupAddress.roadName.name,
                inBuildingNumber: `${this.pickupAddress.roadName.subBuildingNumber
                    ? `${this.pickupAddress.roadName.mainBuildingNumber}-${this.pickupAddress.roadName.subBuildingNumber}`
                    : this.pickupAddress.roadName.mainBuildingNumber}`,
            });
        }
        else {
            address = getAddressData({
                inSiDo: this.pickupAddressSiDo,
                inSiGungu: this.pickupAddressSiGunGu,
                inEupMyeonDong: this.pickupAddressDong,
                inLi: this.pickupAddressLi,
                inJibun: this.pickupAddressJibun,
                inRoad: this.pickupAddressRoad,
                inBuildingNumber: this.pickupAddressBuildingNumber,
                inBuildingName: this.pickupAddressBuildingName,
                inDetail: this.pickupAddressDetail,
            });
        }
        return [
            address.siDo,
            address.siGunGu,
            address.eupMyeonDong,
            address.li,
            address.jibun,
            address.buildingNumber,
            address.buildingName,
            address.enclosedRoad,
            address.detail,
        ]
            .filter((it) => !!it)
            .join(' ');
    }
    /**
     * 출발지 주소 시도, 시군구 제외
     * */
    getPickupShortAddress() {
        let address = {};
        if (this.pickupAddress?.siDo) {
            address = getAddressData({
                inBuildingName: this.pickupAddress.buildingName,
                inDetail: this.pickupAddress.detail,
                // lotNumber / 지번 / 구주소
                inEupMyeonDong: this.pickupAddress.lotNumber.dong,
                inLi: this.pickupAddress.lotNumber.ri,
                inJibun: `${this.pickupAddress.lotNumber.subNumber
                    ? `${this.pickupAddress.lotNumber.mainNumber}-${this.pickupAddress.lotNumber.subNumber}`
                    : this.pickupAddress.lotNumber.mainNumber}`,
                // roadName / 도로명 / 신주소
                inRoad: this.pickupAddress.roadName.name,
                inBuildingNumber: `${this.pickupAddress.roadName.subBuildingNumber
                    ? `${this.pickupAddress.roadName.mainBuildingNumber}-${this.pickupAddress.roadName.subBuildingNumber}`
                    : this.pickupAddress.roadName.mainBuildingNumber}`,
            });
        }
        else {
            address = getAddressData({
                inEupMyeonDong: this.pickupAddressDong,
                inLi: this.pickupAddressLi,
                inJibun: this.pickupAddressJibun,
                inRoad: this.pickupAddressRoad,
                inBuildingNumber: this.pickupAddressBuildingNumber,
                inBuildingName: this.pickupAddressBuildingName,
                inDetail: this.pickupAddressDetail,
            });
        }
        return [
            address.eupMyeonDong,
            address.li,
            address.jibun,
            address.buildingNumber,
            address.buildingName,
            address.enclosedRoad,
            address.detail,
        ]
            .filter((it) => !!it)
            .join(' ');
    }
    /**
     * 도착지 주소
     * 불광동 173 불광중학교 영빈테스트
     * 시군구 없음
     */
    // 원본 백업
    // getDropFullAddress() {
    //   const dropKeys: string[] = [
    //     'dropAddressDong',
    //     'dropAddressLi',
    //     'dropAddressJibun',
    //     'dropAddressBuildingName',
    //     'dropAddressDetail',
    //   ];
    //   return dropKeys.map((key: any) => (this as any)[key] ?? '').join(' ');
    // }
    getDropFullAddress() {
        let address = {};
        if (this.dropAddress?.siDo) {
            address = getAddressData({
                inSiDo: this.dropAddress.siDo,
                inSiGungu: this.dropAddress.siGunGu,
                inBuildingName: this.dropAddress.buildingName,
                inDetail: this.dropAddress.detail,
                // lotNumber / 지번 / 구주소
                inEupMyeonDong: this.dropAddress.lotNumber.dong,
                inLi: this.dropAddress.lotNumber.ri,
                inJibun: `${this.dropAddress.lotNumber.subNumber
                    ? `${this.dropAddress.lotNumber.mainNumber}-${this.dropAddress.lotNumber.subNumber}`
                    : this.dropAddress.lotNumber.mainNumber}`,
                // roadName / 도로명 / 신주소
                inRoad: this.dropAddress.roadName.name,
                inBuildingNumber: `${this.dropAddress.roadName.subBuildingNumber
                    ? `${this.dropAddress.roadName.mainBuildingNumber}-${this.dropAddress.roadName.subBuildingNumber}`
                    : this.dropAddress.roadName.mainBuildingNumber}`,
            });
        }
        else {
            address = getAddressData({
                inSiDo: this.dropAddressSiDo,
                inSiGungu: this.dropAddressSiGunGu,
                inEupMyeonDong: this.dropAddressDong,
                inLi: this.dropAddressLi,
                inJibun: this.dropAddressJibun,
                inRoad: this.dropAddressRoad,
                inBuildingNumber: this.dropAddressBuildingNumber,
                inBuildingName: this.dropAddressBuildingName,
                inDetail: this.dropAddressDetail,
            });
        }
        return [
            // address.siDo,
            // address.siGunGu,
            address.eupMyeonDong,
            address.li,
            address.jibun,
            // address.buildingNumber,
            address.buildingName,
            // address.enclosedRoad,
            address.detail,
        ]
            .filter((it) => !!it)
            .join(' ');
    }
    /**
     * 도착지 주소
     * 개인정보 숨김 버전
     * */
    dropAddressForPrivacy() {
        const { siDo, siGunGu, eupMyeonDong, li, jibun, buildingNumber, buildingName, enclosedRoad, detail, } = getAddressData({
            inSiDo: this.dropAddressSiDo,
            inSiGungu: this.dropAddressSiGunGu,
            inEupMyeonDong: this.dropAddressDong,
            inLi: this.dropAddressLi,
            inJibun: this.dropAddressJibun,
            inRoad: this.dropAddressRoad,
            inBuildingNumber: this.dropAddressBuildingNumber,
            inBuildingName: this.dropAddressBuildingName,
            inDetail: this.dropAddressDetail,
        });
        if (OrderPolicy.doMaskDropInfo(this)) {
            return [
                eupMyeonDong,
                li,
                jibun,
            ]
                .filter((it) => !!it)
                .join(' ').concat('*'.repeat(6));
        }
        return [
            siDo,
            siGunGu,
            eupMyeonDong,
            li,
            jibun,
            buildingNumber,
            buildingName,
            enclosedRoad,
            detail,
        ]
            .filter((it) => !!it)
            .join(' ');
    }
    /**
     * 도착지 주소 축약 버전
     * 도동 637-2 전체할증확인 8664
     */
    dropAddressShorten({ dropAddressDong, dropAddressLi, dropAddressJibun, dropAddressBuildingName, dropAddressDetail, } = this) {
        const { eupMyeonDong, li, jibun, buildingName, detail, } = getAddressData({
            inEupMyeonDong: dropAddressDong,
            inLi: dropAddressLi,
            inJibun: dropAddressJibun,
            inBuildingName: dropAddressBuildingName,
            inDetail: dropAddressDetail,
        });
        if (OrderPolicy.doMaskDropInfo(this)) {
            return [
                eupMyeonDong,
                li,
                jibun,
            ]
                .filter((it) => !!it)
                .join(' ').concat('*'.repeat(6));
        }
        return [
            eupMyeonDong,
            li,
            jibun,
            buildingName,
            detail,
        ]
            .filter((it) => !!it)
            .join(' ');
    }
    /**
     * 주문을 접수건으로 변경함.
     * 접수건의 대표적 상태 -> 배차정보를 제거
     */
    changeToAccepted() {
        this.allocatedWorkerCode = '';
        this.allocatedWorkerName = '';
    }
    /**
     * 지연건 체크
     * @param text
     * @returns
     */
    checkDelayedOrder(text) { return text.startsWith('-'); }
    /**
     * orderAgencyOptions 객체 초기화
     * @param orderData 주문 객체
     */
    initOrderAgencyOptions() {
        // orderAgencyOptions 필요 없으면 패스
        // 대리접수는 필요 없음..
        if (!this.orderAgencyId) {
            return;
        }
        const tmp = {};
        if (!this.orderAgencyOptions) {
            tmp.includeAlcohol = this._includeAlcohol;
            tmp.allocateLimit = this._allocateLimit;
            tmp.purchaseType = this._purchaseType;
            tmp.cancelFee = this._cancelFee;
            tmp.serviceLevelAgreementDeliveryTime = this._serviceLevelAgreementDeliveryTime;
        }
        else {
            tmp.includeAlcohol = this.orderAgencyOptions.includeAlcohol;
            tmp.allocateLimit = this.orderAgencyOptions.allocateLimit;
            tmp.purchaseType = this.orderAgencyOptions.purchaseType;
            tmp.cancelFee = this.orderAgencyOptions.cancelFee;
            tmp.serviceLevelAgreementDeliveryTime = this
                .orderAgencyOptions.serviceLevelAgreementDeliveryTime;
        }
        const orderAgencyOptionParam = {
            includeAlcohol: tmp.includeAlcohol,
            allocateLimit: tmp.allocateLimit,
            purchaseType: tmp.purchaseType,
            cancelFee: tmp.cancelFee,
            serviceLevelAgreementDeliveryTime: tmp.serviceLevelAgreementDeliveryTime,
        };
        // 주소기반은 항시 신규 객체로 생성
        this.orderAgencyOptions = new OrderAgencyOptions(orderAgencyOptionParam);
    }
    /**
     * orderAgencyOptions 객체 초기화
     * @param orderData 주문 객체
     */
    initOrderAgencyOptions1() {
        // 주소기반배달 아니면 패스
        if (!this.orderAgencyId) {
            return;
        }
        const orderAgencyOptionParam = {};
        if (!this.orderAgencyOptions) {
            orderAgencyOptionParam.includeAlcohol = this.includeAlcohol;
            orderAgencyOptionParam.allocateLimit = this.allocateLimit;
            orderAgencyOptionParam.purchaseType = this.purchaseType;
            orderAgencyOptionParam.cancelFee = this.cancelFee;
            orderAgencyOptionParam.serviceLevelAgreementDeliveryTime = this.serviceLevelAgreementDeliveryTime;
        }
        else {
            orderAgencyOptionParam.includeAlcohol = this.orderAgencyOptions.includeAlcohol;
            orderAgencyOptionParam.allocateLimit = this.orderAgencyOptions.allocateLimit;
            orderAgencyOptionParam.purchaseType = this.orderAgencyOptions.purchaseType;
            orderAgencyOptionParam.cancelFee = this.orderAgencyOptions.cancelFee;
            orderAgencyOptionParam.serviceLevelAgreementDeliveryTime = this
                .orderAgencyOptions.serviceLevelAgreementDeliveryTime;
        }
        // 주소기반은 항시 신규 객체로 생성
        this.orderAgencyOptions = new OrderAgencyOptions({
            includeAlcohol: orderAgencyOptionParam.includeAlcohol,
            allocateLimit: orderAgencyOptionParam.allocateLimit,
            purchaseType: orderAgencyOptionParam.purchaseType,
            cancelFee: orderAgencyOptionParam.cancelFee,
            serviceLevelAgreementDeliveryTime: orderAgencyOptionParam.serviceLevelAgreementDeliveryTime,
        });
    }
    /**
     * 인자로 들어온 주문 객체로 기존 객체 업데이트
     * @param order
     */
    assignOrder(order) {
        Object.keys(order).forEach((key) => {
            const value = order[key];
            if (!value) {
                return;
            }
            this[key] = order[key];
            // 이전 데이터 필요시 별도 상태값으로 저장
            if (!order.preStatusCode) {
                this.preStatusCode = order.statusCode;
            }
            else {
                this.preStatusCode = order.preStatusCode;
            }
        });
    }
}
